import { Component } from "react";
import "../App.css";

export class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Uncaught render error:", error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="empty-result">
        <h1 className="text-hero">
          Who Would <span className="hero-accent">Win</span>
        </h1>
        <h2 className="empty-result-title">Something went wrong</h2>
        <p className="empty-result-sub">
          An unexpected error occurred. Reloading the page should fix it.
        </p>
        <button className="fight-btn" style={{ maxWidth: 320 }} onClick={() => window.location.reload()}>
          Reload
        </button>
      </div>
    );
  }
}
